import React, {
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from "react";
import { Plan } from "../../@types";
import { FormattedMessage } from "react-intl-phraseapp";
import { AppPage, ErrorPage } from "../../components";
import { AppStore } from "../../app/store";
import { useTranslate } from "../../helpers";
import { PageHeader, SanctionedPlanCards } from ".";
import { requestSanctionedPlans as rSP, SPPStateProps } from "./Helpers";
import Pagination from "../../components/Pagination";

const SanctionedPlansPage: FunctionComponent = () => {
  const { state } = useContext(AppStore.AppContext);
  const [SPPState, setSPPState] = useState<SPPStateProps>({
    pageError: false,
    totalPlans: 0,
    currentPage: [] as Plan[],
    pageCount: 0,
    currentPageIdx: 0,
    loadingPlans: false,
  });
  const t = useTranslate();

  const updatePageState = (newState: Partial<SPPStateProps>): void =>
    setSPPState({ ...SPPState, ...newState });

  const requestSanctionedPlans = (
    page: number | undefined,
    scrollToTop: boolean
  ): Promise<void> => rSP(page, scrollToTop, state, updatePageState);

  const pageClickHandler = (page: number): void => {
    requestSanctionedPlans(page, false);
  };

  useEffect(() => {
    if (state.fips && state.planType && state.year) {
      requestSanctionedPlans(undefined, false);
    }
  }, [state.fips, state.zipcode, state.planType, state.year]);

  if (SPPState.pageError) return <ErrorPage />;

  return (
    <AppPage headerExtension={<PageHeader totalPlans={SPPState.totalPlans} />}>
      <ul>
        <div className="ShowingTotalSanctioned">
          <span role="status" aria-live="polite" aria-atomic="true">
            {!SPPState.loadingPlans && (
              <FormattedMessage
                id="search_results_page.total_plans"
                tagName="span"
                values={{
                  pluralPlanType: t("sanctioned_plans_page.sanctioned_plans"),
                  current: SPPState.currentPage.length,
                  total: SPPState.totalPlans,
                }}
              />
            )}
          </span>
        </div>

        <SanctionedPlanCards currentPage={SPPState.currentPage} />
      </ul>

      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.cms.gov/Medicare/Compliance-and-Audits/Part-C-and-Part-D-Compliance-and-Audits/PartCandPartDEnforcementActions-.html"
      >
        {t("sanctioned_plans_page.learn_more_link")}
      </a>

      {SPPState.pageCount > 1 && (
        <>
          <div className="ds-u-display--flex ds-u-justify-content--end">
            <Pagination
              currentPage={SPPState.currentPageIdx}
              totalPages={SPPState.pageCount}
              totalResults={SPPState.totalPlans}
              onPageSelect={pageClickHandler}
            />
          </div>
          <div className="ds-u-display--flex ds-u-justify-content--end">
            <span className="ds-u-font-size--sm ds-u-margin-y--2 ds-u-lg-margin-x--6">
              <FormattedMessage
                id="search_results_page.total_plans"
                tagName="span"
                values={{
                  pluralPlanType: t("sanctioned_plans_page.sanctioned_plans"),
                  current: SPPState.currentPage.length,
                  total: SPPState.totalPlans,
                }}
              />
            </span>
          </div>
        </>
      )}
    </AppPage>
  );
};

export default SanctionedPlansPage;
